import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppConfig } from '@app/app.config';
import { I18nService } from '@eng-ds/translate';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class PageTitleService {
	constructor(
		private title: Title,
		private i18n: I18nService,
		private menuService: NbMenuService
	) {}

	listenForUpdate(): Observable<NbMenuItem> {
		return this.menuService.onItemSelect().pipe(
			map(el => el && el.item),
			tap((item: NbMenuItem) => {
				this.title.setTitle(this._buildTitle(item));
			})
		);
	}

	private _buildTitle(item: NbMenuItem): string {
		const title = [];
		let iterator = item;

		while (iterator) {
			title.push(iterator.title);
			iterator = iterator.parent;
		}

		title.push(AppConfig.company + ' ' + this.i18n.translate('APP.NAME'));

		return title.reverse().join(' - ');
	}
}
